<custom-modal-card [enableHeader]="false" class="delete-popup">
  <article class="delete-popup__content" body>
    <img
      src="assets/images/delete-modal-trash.png"
      alt="Delete"
      height="10"
      width="10"
    />
    <div>
      <section>
        <h2 class="delete-popup__title">
          {{ title() || defaultTitle }}
        </h2>
        <p class="delete-popup__description">
          {{ subtitle() || defaultSubtitle }}
        </p>
        @if (showFullContent()) {
          <p class="instruction">
            {{ instruction() || defaultInstruction }}

            <span class="sentence"
              >"{{ wordEntry() || defaultWordEntry }}"</span
            >
          </p>
        }
      </section>
      @if (showFullContent()) {
        <input
          type="text"
          class="form__input"
          [(ngModel)]="inputValue"
          [placeholder]="wordEntry()"
        />
      }

      <hr />

      <section class="delete-popup__actions">
        <button
          type="button"
          button
          size="default"
          variant="outline"
          [fullWidth]="false"
          [disabled]="isButtonDisabled"
          [loading]="isLoading()"
          (click)="confirm()"
        >
          {{ action() || 'Supprimer définitivement' }}
        </button>
        <button
          type="button"
          button
          size="default"
          [fullWidth]="false"
          variant="ghost"
          mat-dialog-close
        >
          {{ cancel() || 'Annuler la suppression' }}
        </button>
      </section>
    </div>
  </article>
</custom-modal-card>
